import { NavLink, useLocation } from 'react-router-dom';
import { isSectionSubnavLinkActive } from './sectionSubnavState.js';

export type SectionNavItem = {
  to: string;
  label: string;
  testId: string;
  group?: string;
};

function clusterNavItems(items: SectionNavItem[]): SectionNavItem[][] {
  const clusters: SectionNavItem[][] = [];
  for (const item of items) {
    const last = clusters[clusters.length - 1];
    if (last && last[0]?.group === item.group) {
      last.push(item);
    } else {
      clusters.push([item]);
    }
  }
  return clusters;
}

function SubnavLink({
  item,
  pathname,
  search,
}: {
  item: SectionNavItem;
  pathname: string;
  search: string;
}) {
  const active = isSectionSubnavLinkActive(pathname, item.to, search);
  return (
    <NavLink
      to={item.to}
      className={`mer-section-subnav-link${active ? ' mer-section-subnav-link-active' : ''}`}
      data-testid={item.testId}
      data-active={active ? 'true' : 'false'}
      aria-current={active ? 'page' : undefined}
    >
      {item.label}
    </NavLink>
  );
}

export function SectionSubnav({
  items,
  ariaLabel,
  testId = 'merchant-section-subnav',
}: {
  items: SectionNavItem[];
  ariaLabel: string;
  testId?: string;
}) {
  const { pathname, search } = useLocation();

  if (items.length === 0) return null;

  const clusters = clusterNavItems(items);
  const grouped = clusters.length > 1 && items.some((item) => item.group);

  return (
    <nav
      className={`mer-section-subnav${grouped ? ' mer-section-subnav--grouped' : ''}`}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      {grouped
        ? clusters.map((cluster, index) => (
            <div key={cluster[0]?.group ?? `cluster-${index}`} className="mer-section-subnav-group">
              {cluster.map((item) => (
                <SubnavLink key={item.testId} item={item} pathname={pathname} search={search} />
              ))}
            </div>
          ))
        : items.map((item) => (
            <SubnavLink key={item.testId} item={item} pathname={pathname} search={search} />
          ))}
    </nav>
  );
}
